<template>
  <v-dialog
    v-if="value"
    :model-value="Boolean(value)"
    class="pb-4"
    color="primary"
    max-width="calc(100% - 6rem)"
    persistent
    scrim="rgba(0, 0, 0, 0.65)"
    scrollable
    @update:model-value="handleUpdate"
  >
    <v-card>
      <v-card-title class="pa-4 flex-column v-header--fixed">
        <div class="d-flex justify-end" style="width: 100%">
          <v-btn icon variant="text" @click="$emit('close-modal', null)">
            <icon height="14" width="14">close-x</icon>
          </v-btn>
        </div>

        <div v-if="showTitle" class="pt-2">
          <icon
            key="video-off-icon"
            class="d-block mx-auto mt-n4 mb-5"
            error
            height="54"
            scaleStroke
            width="54"
          >
            exclamation-triangle
          </icon>
          <h4 class="text-center mb-2">Error</h4>
        </div>
      </v-card-title>
      <v-card-text class="ma-0 pa-0">
        <v-container class="pb-8 text-center text-body-2">
          <v-row>
            <v-col class="px-8">
              <div v-html="value"></div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="pa-0 flex-column">
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="primary"
                rounded
                size="large"
                variant="flat"
                width="100%"
                @click="$emit('close-modal', null)"
              >
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ErrorModal',
  props: {
    value: String,
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleUpdate(isOpen) {
      if (!isOpen) this.$emit('close-modal', null);
    }
  }
};
</script>
